import React from 'react';

const LoadingCard = ({ isMobileCard = false }) => (
  <div className={isMobileCard ? "mobile-work-card" : "col-lg-4 col-md-6"}>
    <div className="work-card h-100" style={{ minHeight: '300px' }}>
      <div className="work-image-container" style={{ background: 'rgba(255,255,255,0.1)' }}>
        <div className="d-flex align-items-center justify-content-center h-100">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
      <div className="card-content">
        <div className="placeholder-glow">
          <span className="placeholder col-8 mb-3"></span>
          <span className="placeholder col-12 mb-2"></span>
          <span className="placeholder col-10"></span>
        </div>
      </div>
    </div>
  </div>
);

export default LoadingCard;